import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import { Link } from 'react-router';

import RaisedButton from 'material-ui/RaisedButton';
import KeyboardArrowLeftIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import DoneIcon from 'material-ui/svg-icons/action/done';
import HighlightOffIcon from 'material-ui/svg-icons/action/highlight-off';

import Sidebar from './Sidebar';
import ErrorBoundary from './ErrorBoundary';
import ServiceProviders from './ServiceProviders/Component';
import PortRestrictions from './PortRestrictions';
import LiftAndCranes from './LiftAndCranes/List';
import Facilities from './Facilities';
import Warehouses from './Warehouses';
import Other from './Other';

import { getPort, clearPort } from 'actions/regions/ports';

import api from 'services';
import MyMapComponent from '../PortAdd/MapComponent';
import constants from 'constants';

const styles = {
    btnBack: {
        labelStyle: { color: '#fff', textTransform: 'none', fontSize: '13px' },
        style: { margin: '20px 0 70px 0' },
    },
    btnSubmit: {
        labelStyle: { color: '#fff', textTransform: 'none', fontSize: '13px' },
        style: { margin: '20px 0 70px 0' },
    },
};

class PortApprove extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            port: props.port,
            addedBy: { email: '', name: '' },
            newPort: props.port,
            serviceProviders: props.port.serviceProviders,
            newServiceProviders: props.port.serviceProviders,
            disabled: false,
            liftsCranes: props.port.liftsCranes,
        };

        this.approvePort = this.approvePort.bind(this);
        this.rejectPort = this.rejectPort.bind(this);

        this.approveServiceProvider = this.approveServiceProvider.bind(this);
        this.rejectServiceProvider = this.rejectServiceProvider.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { routeParams: { id }, getPort } = this.props;
        getPort({ id, history: true, all: true });
    }

    approvePort() {
        api.approvePortModifications({
            _id: this.state.port._id,
            historyId: this.state.port.history[0]._id,
            updateAt: Date.parse(this.state.port.history[0].updateAt),
        })
            .then((response) => {
                if (response.status === 200) {
                    const { routeParams: { id }, getPort, clearPort } = this.props;
                    clearPort();
                    return getPort({ id, history: true, all: true });
                }
            })
            .catch((response) => {
                console.log('error', response);
            });
    }

    rejectPort() {
        api.rejectPortModifications({
            _id: this.state.port._id,
            historyId: this.state.port.history[0]._id,
            updateAt: Date.parse(this.state.port.history[0].updateAt),
        })
            .then((response) => {
                if (response.status === 200) {
                    const { routeParams: { id }, getPort, clearPort } = this.props;
                    clearPort();
                    return getPort({ id, history: true, all: true });
                }
            })
            .catch((response) => {
                console.log('error', response);
            });
    }

    approveServiceProvider(serviceProvider) {
        api.approveServiceProvider({
            _id: serviceProvider._id,
            historyId: serviceProvider.history._id,
            updateAt: Date.parse(serviceProvider.history.updateAt),
        })
            .then((response) => {
                if (response.status === 200) {
                    const { routeParams: { id }, getPort, clearPort } = this.props;
                    clearPort();
                    return getPort({ id, history: true, all: true });
                }
            })
            .catch((response) => {
                console.log('error', response);
            });
    }

    rejectServiceProvider(serviceProvider) {
        api.rejectServiceProvider({
            _id: serviceProvider._id,
            historyId: serviceProvider.history._id,
            updateAt: Date.parse(serviceProvider.history.updateAt),
        })
            .then((response) => {
                if (response.status === 200) {
                    const { routeParams: { id }, getPort, clearPort } = this.props;
                    clearPort();
                    return getPort({ id, history: true, all: true });
                }
            })
            .catch((response) => {
                console.log('error', response);
            });
    }

    componentWillUnmount() {
        this.props.clearPort();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let port = nextProps.port;
        let newPort = nextProps.port;

        let disabled = false;
        let addedBy = this.state.addedBy;

        let serviceProviders = nextProps.port.serviceProviders;
        let newServiceProviders = nextProps.port.serviceProviders;

        let liftsCranes = nextProps.port.liftsCranes;
        let newLiftsCranes = nextProps.port.liftsCranes;

        if (nextProps.port.firstLoad && nextProps.port.history && nextProps.port.history.length === 0) {
            nextProps.clearPort();
            nextProps.router.push(`/regions/ports/${nextProps.routeParams.id}`);
        }

        if (nextProps.port.history && nextProps.port.history.length > 0) {
            port = Object.assign({}, nextProps.port, nextProps.port.history[0].originalValues);
            newPort = Object.assign({}, nextProps.port, nextProps.port.history[0].changedValues);

            if (!port.portLimitations) {
                port.portLimitations = nextProps.port.portLimitations;
            }

            if (!nextProps.port.history[0].changedValues.portLimitations) {
                delete newPort.portLimitations;
            }

            addedBy = nextProps.port.history[0].addedBy;

            serviceProviders = [...nextProps.port.history[0].originalValues.serviceProviders];
            newServiceProviders = [...nextProps.port.history[0].changedValues.serviceProviders];
            
            if (nextProps.port.history[0].originalValues.liftsCranes) {
                liftsCranes = { ...nextProps.port.history[0].originalValues.liftsCranes };
            }

            newLiftsCranes = { ...nextProps.port.history[0].changedValues.liftsCranes };

            serviceProviders.forEach((serviceProvider) => {
                const currentServiceProvider = newServiceProviders.find(newServiceProvider => serviceProvider._id === newServiceProvider._id);

                if (currentServiceProvider && currentServiceProvider.history.length !== 0) {
                    serviceProvider.status = 'change';
                    serviceProvider.provider = currentServiceProvider.history[0].changedValues;
                    serviceProvider.history = currentServiceProvider.history[0];

                    disabled = true;
                } else if (currentServiceProvider && currentServiceProvider.history.length === 0) {
                    serviceProvider.status = 'normal';
                } else {
                    serviceProvider.status = 'remove';
                }
            });

            newServiceProviders.forEach((newServiceProvider) => {
                const currentServiceProvider = serviceProviders.find(serviceProvider => serviceProvider._id === newServiceProvider._id);

                if (!currentServiceProvider) {
                    serviceProviders.push(newServiceProvider);
                    serviceProviders[serviceProviders.length - 1].status = 'new';
                }
            });

            serviceProviders = [...serviceProviders, ...nextProps.port.serviceProviders];
            serviceProviders = _.uniqBy(serviceProviders, '_id');

            serviceProviders.forEach((serviceProvider) => {
                if (!serviceProvider.status) {
                    serviceProvider.status = 'normal';
                }
            });

            for (let key in liftsCranes) {
                liftsCranes[key].details.forEach((detail) => {
                    let currentDetail = newLiftsCranes[key].details.find((newDetail) => {
                        return detail._id === newDetail._id;
                    });

                    if (currentDetail && (detail.value !== currentDetail.value || detail.name !== currentDetail.name)) {
                        detail.status = 'change';
                        detail.changes = currentDetail;
                    } else if (currentDetail) {
                        detail.status = 'normal';
                        detail.changes = currentDetail;
                    } else {
                        detail.status = 'remove';
                    }
                });
            }

            for (let key in newLiftsCranes) {
                newLiftsCranes[key].details.forEach((newDetail) => {
                    let currentDetail = liftsCranes[key] && liftsCranes[key].details.find((detail) => {
                        return detail._id === newDetail._id;
                    });

                    if (!currentDetail) {
                        liftsCranes[key].details.push(newDetail);
                        liftsCranes[key].details[liftsCranes[key].details.length - 1].status = 'new';
                    }
                });
            }
        }

        this.setState({
            port,
            addedBy,
            newPort,
            serviceProviders,
            newServiceProviders,
            disabled,
            liftsCranes,
        });
    }

    render() {
        const {
            port, newPort, addedBy, serviceProviders, disabled, liftsCranes, 
        } = this.state;

        return (
            <div className='container' id='single-port'>
                <div className="management">
                    <div className="btn">
                        <RaisedButton
                            label="Back to list"
                            style={styles.btnBack.style}
                            labelStyle={styles.btnBack.labelStyle}
                            labelPosition="before"
                            icon={<KeyboardArrowLeftIcon />}
                            containerElement={<Link to='/regions/ports' />}
                            primary
                        />
                    </div>
                    <div className="btn">
                        <RaisedButton
                            label="Approve port modification"
                            style={styles.btnSubmit.style}
                            labelStyle={styles.btnSubmit.labelStyle}
                            labelPosition="before"
                            icon={<DoneIcon />}
                            backgroundColor="#a4c639"
                            onClick={this.approvePort}
                            disabled={disabled}

                        />
                    </div>
                    <div className="btn">
                        <RaisedButton
                            label="Reject port modification"
                            style={styles.btnSubmit.style}
                            labelStyle={styles.btnSubmit.labelStyle}
                            labelPosition="before"
                            icon={<HighlightOffIcon />}
                            backgroundColor="#f00"
                            onClick={this.rejectPort}
                            disabled={disabled}
                        />
                    </div>
                </div>

                <div className="management">
                    <div className="paper-block">
                        <span className="name-block">Added by</span>
                        <div>Email - {addedBy.email}</div>
                        <div>Name - {addedBy.name}</div>
                    </div>
                </div>

                <div className="row">
                    <ErrorBoundary>
                        <Sidebar
                            port={port}
                            newPort={newPort}
                        />
                    </ErrorBoundary>
                    <div className="col-lg-9 col-xs-9 main">
                        <ErrorBoundary>
                            <div className='add-coords-map'>
                                <div className='main__title'>Coordinates</div>
                                <MyMapComponent
                                    coordinates={port.coordinates}
                                    // change={(key, value) => {
                                    //     this.props.changePort({ coordinates: value });
                                    // }}
                                    googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${constants.GOOGLE_MAP_API_KEY}`}
                                    loadingElement={<div style={{ height: '100%' }} />}
                                    containerElement={<div style={{ width: '100%', height: '300px' }} />}
                                    mapElement={<div style={{ height: '100%' }} />}
                                    rememberOldCoords
                                />
                            </div>
                        </ErrorBoundary>
                        <ErrorBoundary>
                            <ServiceProviders
                                serviceProviders={serviceProviders}
                                approveServiceProvider={this.approveServiceProvider}
                                rejectServiceProvider={this.rejectServiceProvider}
                            />
                        </ErrorBoundary>

                        <ErrorBoundary>
                            <PortRestrictions
                                port={port}
                                newPort={newPort}
                            />
                        </ErrorBoundary>

                        <ErrorBoundary>
                            <LiftAndCranes
                                liftsCranes={liftsCranes}
                                port={port}
                                newPort={newPort}
                            />
                        </ErrorBoundary>

                        <ErrorBoundary>
                            <Facilities
                                port={port}
                                newPort={newPort}
                            />
                        </ErrorBoundary>

                        <ErrorBoundary>
                            <Warehouses
                                port={port}
                                newPort={newPort}
                            />
                        </ErrorBoundary>

                        <ErrorBoundary>
                            <Other
                                port={port}
                                newPort={newPort}
                            />
                        </ErrorBoundary>
                    </div>
                </div>
            </div>
        );
    }
}

PortApprove.propTypes = {

};

PortApprove.defaultProps = {

};

export default connect(
    ({ port, user: { isLogged } }) => ({
        port,
        isLogged,
    }),
    dispatch => bindActionCreators({
        getPort,
        clearPort,
    }, dispatch),
)(PortApprove);



// WEBPACK FOOTER //
// ./app/components/Regions/PortApprove/Page.jsx